"use client";

import { useResumeStore } from "@/lib/store/resume";
import { Input } from "@nextui-org/react";
import { PencilLine } from "lucide-react";
import { useEffect, useRef, useState } from "react";

type TProps = {
  icon: any;
  title?: string;
  id?: string;
  isDisableEdit?: boolean;
};
const Header = (props: TProps) => {
  const { icon, title = "", id, isDisableEdit = false } = props;
  const { setValue, resume } = useResumeStore();
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<any>(null);
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setIsEditing(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef]);

  return (
    <header className="flex items-center">
      <div className="mr-2 font-bold">{icon}</div>
      <div>
        {!isDisableEdit && isEditing ? (
          <Input
            ref={inputRef}
            autoFocus
            variant="underlined"
            placeholder="Enter your email"
            size="sm"
            defaultValue={title}
            className="h-[48px] w-[200px]"
            style={{ fontSize: "14px", fontWeight: "500" }}
            onBlur={() => setIsEditing(false)}
            onValueChange={(value) => setValue(`sections.${id}.name`, value)}
          />
        ) : (
          <div className="flex items-center justify-center">
            <p
              // style={{ fontSize: "20px", lineHeight: "48px" }}
              className="text-lg font-bold"
              onClick={() => setIsEditing(true)}
            >
              {title}
            </p>
            <PencilLine
              className="ml-1 cursor-pointer text-zinc-500"
              size={14}
              onClick={() => setIsEditing(true)}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
